import styled from "styled-components";

export const Wrapper = styled.div`
    position: relative;
    margin-bottom: 0px;
    & * {
        font-size: 100% !important;
    }
     & #static-label {
        font-size: 14px !important; /* Or any other font-size you wish to apply */
    }
`